module.exports = __webpack_public_path__ + "static/media/aboutus.1133b996.jpg";